/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Job} from '@jobseeker/common-core/types';
import Dialog from '@jobseeker/lotus/components/Dialog';
import {deleteCookie, getCookie} from 'cookies-next';
import kebabCase from 'lodash/kebabCase';
import debounce from 'lodash/throttle';
import dynamic from 'next/dynamic';
import {useRouter} from 'next/router';
import {
  Dispatch,
  memo,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {
  calendarService,
  jobDetailService,
  jobfeedService,
  userService,
} from '@jobseeker/common-core/services';
import {
  getFormatedProfile,
  handleTracking,
  TrackEventUBA,
} from '@jobseeker/common-core/utils';
import {getRefEmbedded} from '@jobseeker/common-core/utils/refTrack';
import {CautionIcon, ChevronRight} from '@jobseeker/lotus/assets/icons';
import Loader from '@jobseeker/lotus/components/Loader';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import Grid from '@jobseeker/lotus/foundations/Layouts/Grid';
import {
  useIsCustomWidth,
  useIsLargeDevice,
  useWrappedTheme,
} from '@jobseeker/lotus/hooks';
import {Image} from '@jobseeker/lotus/components/Image';

import {
  alumniPageJobs,
  fetchCategoryJobFeed,
  fetchIndustryData,
  fetchLocationBasedJobFeed,
  fetchRecuiterJobFeed,
  fetchTagJobFeed,
  fetchUserJobFeed,
  searchJobsbyQuery,
} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import ImageGallery from '../../Banner';

import {
  getExpFilter,
  getPrefText,
  openUrl,
  setExpFilter,
  deferTask,
} from '@jobseeker/common-core/utils/common';

import InjectSearchOverlay from '@components/SearchInjection';
import StoryInjection from '@components/StoryInjection';
import {
  ALUMNI,
  CATEGORY,
  COMPANY,
  COURSE,
  EXPERIENCE_MAPPING,
  JOBFEED,
  LOCATION_BASED,
  MYJOBFEED,
  RECRUITER_JOBFEED,
  ROUTE_JOB_DETAIL,
  ROUTE_SEARCH,
  SEARCH,
  TAG,
} from '@constants';
import {
  getOldLink,
  getProLink,
  isCSR,
  locationMap,
} from '@jobseeker/lotus/utils';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

import BlogsPanel from '@jobseeker/feature-ads/components/BlogsPanel';
import InterviewInvitesNotifier from '@jobseeker/feature-job/components/Interview/Hirist/InterviewInvitesNotifier';
import Button from '@jobseeker/lotus/elements/Button';
import {Box} from '@jobseeker/lotus/foundations/Layouts/Box';
import {Card, Link, Skeleton, styled, Typography} from '@mui/material';
import {formQueryParams, getLocationIds, setQueryParams} from '@utils';
import {getListSEOContent} from '@utils/seo';
import {isEqual} from 'lodash';
import {ParsedUrlQuery} from 'querystring';
import Sticky from 'react-stickynode';
import {SeoIntrup} from '../../SeoLayout';

import type {AppState, Course, UserState} from '@jobseeker/common-core/types';

import JobsByLocation from '@components/JobDetail/JobsByLocation';
import FloatingDownloadButton from '@jobseeker/feature-ads/components/FloatingDownloadButton';
import HiristCourseFeed from '@jobseeker/feature-course/components/HiristCourseFeed';
import {CompanyJobFeed} from '@jobseeker/feature-job/components';
import {HiristCompanyFeed} from '@jobseeker/lotus/components';

type JobFeedLayoutProps = {
  jobFeedType: string;
  catOrTagId: string;
  catOrTagTitle: string;
  showProfileCard: boolean;
  showFeatured?: boolean;
  showLearning?: boolean;
  showLearnGrow?: boolean;
  showLearningCenterCTA?: boolean;
  variant?: VersionVariants;
  feedOnly?: boolean;
  calledType?: string;
  showFeaturedInstitute?: boolean;
  showRolesAtLeadingBrands?: boolean;
  showPlatinumPartners?: boolean;
  showSalesEvent?: boolean;
  showIndustry?: boolean;
  showStickyFilter?: boolean;
  showApplyButton?: boolean;
  showCourses?: boolean;
  hideSidebar?: boolean;
  showFreeProBannerToday?: boolean;
  preFilters?:
    | {
        page: number;
      }
    | any;
  courses?: Course[] | any[];
  companyJobs?: any;
  setPageNumber?: Dispatch<SetStateAction<number>>;
  onFiltersChange?: (filters: any) => void;
  nearByCitiesJobs?: any;
  extractedParams?: any;
  searchType?: number;
};

type CallParamType = {
  userId: string;
  catOrTagId: string;
  slugId?: number;
  type?: string;
  page?: number;
  minexp?: number;
  maxexp?: number;
  param?: any;
  searchType?: number;
};

const getJobFeedCallByType = (
  type: string,
  callParam: CallParamType,
  dispatch: Dispatch</* eslint-disable @typescript-eslint/no-explicit-any */ any>
) => {
  const feedCall: {
    [key: string]: /* eslint-disable @typescript-eslint/no-explicit-any */ any;
  } = {
    [CATEGORY]: () => {
      return dispatch(
        fetchCategoryJobFeed({
          userId: callParam?.userId,
          pageNo: callParam?.page,
          minexp: callParam?.minexp,
          maxexp: callParam?.maxexp,
          catId: callParam?.catOrTagId,
          ...callParam.param,
          loc: callParam?.param?.loc ? callParam?.param?.loc.join(',') : null,
        })
      );
    },
    [TAG]: () => {
      return dispatch(
        fetchTagJobFeed({
          userId: callParam?.userId,
          pageNo: callParam?.page,
          minexp: callParam?.minexp,
          maxexp: callParam?.maxexp,
          query: callParam?.catOrTagId,
          ...callParam.param,
          loc: callParam?.param?.loc ? callParam?.param?.loc.join(',') : null,
        })
      );
    },
    [SEARCH]: () => {
      return dispatch(
        searchJobsbyQuery({
          userId: callParam?.userId,
          pageNo: callParam?.page,
          minexp: callParam?.minexp,
          maxexp: callParam?.maxexp,
          query: callParam?.catOrTagId,
          ...callParam.param,
          loc: callParam?.param?.loc ? callParam?.param?.loc.join(',') : null,
          ...(callParam?.searchType && {searchType: callParam.searchType}),
        })
      );
    },
    [JOBFEED]: () => {
      return dispatch(
        fetchUserJobFeed({
          userId: callParam?.userId,
          pageNo: callParam?.page,
          minexp: callParam?.minexp,
          maxexp: callParam?.maxexp,
          ...callParam.param,
          loc: callParam?.param?.loc ? callParam?.param?.loc.join(',') : null,
        })
      );
    },
    [LOCATION_BASED]: async () => {
      return dispatch(
        fetchLocationBasedJobFeed({
          ...callParam.param,
          userId: callParam?.userId,
          id: callParam?.catOrTagId,
          type: callParam?.type,
        })
      );
    },
    [RECRUITER_JOBFEED]: () => {
      return dispatch(
        fetchRecuiterJobFeed({
          userId: callParam?.userId,
          pageNo: callParam?.page,
          minexp: callParam?.minexp,
          maxexp: callParam?.maxexp,
          recruiterId: callParam?.catOrTagId,
          ...callParam.param,
          loc: callParam?.param?.loc ? callParam?.param?.loc.join(',') : null,
        })
      );
    },
    [ALUMNI]: () => {
      return dispatch(
        alumniPageJobs({
          pageNo: callParam?.param?.page,
          minexp: callParam?.minexp,
          maxexp: callParam?.maxexp,
          size: 20,
          ...callParam.param,
          loc: callParam?.param?.loc ? callParam?.param?.loc.join(',') : null,
          brandJobFlag: '11,12,13,14,15,16,17,18',
        })
      );
    },
  };

  return feedCall[type]();
};

const ProfileCardHarness = dynamic(
  () => import('@jobseeker/client-harness/components/ProfileHarness'),
  {
    ssr: false,
  }
);

const JobFeedEmpty = dynamic(() => import('@components/Empty/Jobfeed'), {
  loading: () => <Loader />,
});

const HiristAuthentication = dynamic(
  () =>
    import(
      '@jobseeker/client-harness/components/HiristAuthenticationHarness/AuthForm'
    ),
  {
    ssr: false,
  }
);

const LoginForm = dynamic(
  () =>
    import(
      '@jobseeker/client-harness/components/AuthenticationHarness/AuthForm'
    ),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const AdsPanelHarness = memo(
  dynamic(
    () => import('@jobseeker/client-harness/components/AdsHarness/AdsPanelV2'),
    {
      ssr: false,
    }
  )
);

const JobfeedHarness = memo(
  dynamic(
    () => import('@jobseeker/client-harness/components/JobHarness/JobfeedV2'),
    {
      loading: () => <Loader />,
    }
  )
);
const CTA = dynamic(() => import('@jobseeker/lotus/components/CTA'), {
  loading: () => <Loader />,
  ssr: false,
});

const DownloadAppJobFeed = dynamic(
  () => import('@jobseeker/lotus/components/DownloadAppJobfeed'),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const DownloadAppJobdetail = dynamic(
  () => import('@jobseeker/lotus/components/DownloadAppJobdetailAndCatogary'),
  {
    loading: () => <Loader />,
    ssr: false,
  }
);

const TabLink = styled(Link)(({theme}) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  transition: 'ease 0.3s',
  position: 'relative',
  '&:hover': {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  '&.active': {
    color: theme.palette.primary.main,
    p: {
      ':before': {
        content: '""',
        position: 'absolute',
        width: '50%',
        height: '3px',
        backgroundColor: theme.palette.primary.main,
        bottom: 0,
        left: '25%',
        borderTopLeftRadius: theme.spacing(0.5),
        borderTopRightRadius: theme.spacing(0.5),
      },
    },
  },
  p: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

const JobFeed = ({
  jobFeedType,
  catOrTagId,
  // catOrTagTitle,
  showProfileCard,
  showFeatured,
  showLearning,
  calledType,
  variant = VersionVariants.VERSION_TWO,
  feedOnly = false,
  showLearningCenterCTA = true,
  preFilters,
  setPageNumber,
  onFiltersChange,
  showFeaturedInstitute,
  showRolesAtLeadingBrands,
  showPlatinumPartners,
  showLearnGrow,
  showSalesEvent,
  nearByCitiesJobs,
  extractedParams,
  searchType,
  showIndustry,
  showStickyFilter,
  showApplyButton,
  showCourses,
  hideSidebar,
  showFreeProBannerToday,
  ...props
}: JobFeedLayoutProps) => {
  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  const router = useRouter();
  const pathname = router.asPath;
  const isAISearchRoute = pathname.startsWith('/ai-search');
  const [loginOpen, setLoginOpen] = useState(false);
  const [catOrTagTitle, setCatOrTagTitle] = useState(props.catOrTagTitle);
  const [twoFaActionOpen, settwoFaActionOpen] = useState(false);
  const [pageNo, setPageNo] = useState(preFilters.page + 1);
  const initialFilter = {page: 0, concat: false};
  const [isCitJobsLoading, setIsLoading] = useState(false);
  const [cityJobs, setCityJobs] = useState<{hasMore: boolean; jobs: Job[]}>(
    nearByCitiesJobs
  );
  const theme = useWrappedTheme();

  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const interceptor: any = useInterceptor();
  const preFilterApplied = useMemo(() => {
    let value = false;
    if (!preFilters) return preFilters;
    for (const key in preFilters) {
      if (!!preFilters[key] && !['page', 'query'].includes(key)) {
        value = true;
        break;
      }
    }
    return value;
  }, [preFilters]);

  const {
    jobfeed: {singleWidget, mulWidget},
    premiumProducts: {earlyApplicant, resumeBuilder},
    proMembership: {userProfileWidget},
  } = interceptor;

  const {device} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );
  const isAboveMobile = device !== 'mobile';
  const isAboveMD = useIsLargeDevice('md');
  let sessionFilter: {minexp?: number; maxexp?: number} = {};
  try {
    if (jobFeedType !== SEARCH) {
      sessionFilter = getExpFilter(jobFeedType);
    }
  } catch (error) {}

  const validateJobApplicationRedirections = (
    profile: any,
    profileCom: any
  ) => {
    const redirectPath =
      typeof window !== 'undefined' ? window.location.href : '/jobfeed';

    // Incomplete Profile Cases
    let profileEdit = '';
    let baseUrl = '';

    if (!profileCom?.personalDetails) {
      profileEdit = `${profileEdit}&pd=pd`;
      baseUrl = `/registration/addPersonalDetails?profiletype=1${profileEdit}&has=1`;
    }

    if (!profileCom?.educationDetails && !baseUrl) {
      profileEdit = `${profileEdit}&ed=ed`;
      baseUrl = `/registration/addEducationalDetails?profiletype=1${profileEdit}&has=1`;
    }

    if (!profileCom?.resumeAttached && !baseUrl) {
      profileEdit = `${profileEdit}&ur=ur`;
      baseUrl = `/registration/addPersonalDetails?profiletype=1${profileEdit}&has=1`;
    }

    if (
      !profileCom?.professionalDetails &&
      !(profile?.experienceStatus === 1) &&
      !baseUrl
    ) {
      profileEdit = `${profileEdit}&pro=pro`;
      baseUrl = `/registration/addWorkExperience?profiletype=1${profileEdit}`;
    }

    if (baseUrl) {
      baseUrl = `${baseUrl}&redirectto=${redirectPath}`;
    }

    return baseUrl;
  };

  const applyMultipleJobs = async (
    jobIds: any[],
    profile: any,
    profileCom: any,
    refCodes?: (number | string | undefined)[]
  ) => {
    try {
      let redirectUrl = validateJobApplicationRedirections(profile, profileCom);
      if (redirectUrl?.length > 0) {
        localStorage.removeItem('applyJobIdsPostLogIn');

        const prefText = getPrefText();

        // Append prefText as a query parameter if it has a value
        if (prefText) {
          const separator = url.includes('?') ? '&' : '?';
          redirectUrl += `${separator}pref=${encodeURIComponent(prefText)}`;
        }
        window.location.href = redirectUrl;
        return;
      }
      const resp = await jobDetailService.applyToMultipleJobs(
        jobIds,
        {
          coverLetter: profile?.coverLetterId,
          jobId: '',
        },
        refCodes
      );

      if (Array.isArray(resp) && resp.every(item => item.success === false)) {
        localStorage.removeItem('applyJobIdsPostLogIn');

        window.location.reload();
        return;
      }

      const jobsAppliedCount = jobIds.length;

      if (localStorage.getItem('applyJobIdsPostLogIn')) {
        let url = `${process.env.NEXT_PUBLIC_LOAD_CONFIG}/job/applied?jobId=${jobIds[0]}&ref=multiapp&count=${jobsAppliedCount}&pref=jf`;
        const prefText = getPrefText();
        localStorage.removeItem('applyJobIdsPostLogIn');

        // Append prefText as a query parameter if it has a value
        if (prefText) {
          const separator = url.includes('?') ? '&' : '?';
          url += `${separator}pref=${encodeURIComponent(prefText)}`;
        }
        window.location.href = url;
      } else {
        openUrl(
          `${process.env.NEXT_PUBLIC_LOAD_CONFIG}/job/applied?jobId=${jobIds[0]}&ref=multiapp&count=${jobsAppliedCount}&pref=jf`
        );
      }

      localStorage.removeItem('applyJobIdsPostLogIn');
    } catch (err) {
      console.error(err);
      window.location.reload();
    }
  };
  const [filters, setFilters] = useState<any>(
    preFilters
      ? {
          ...sessionFilter,
          ...preFilters,
          minexp: preFilters.minexp || sessionFilter.minexp,
          maxexp: preFilters.maxexp || sessionFilter.maxexp,
        }
      : initialFilter
  );
  const [pageMaps, setPageMaps] = useState<number[]>([]);
  // const [filters, setFilters] = useState<any>(initialFilter);

  const {isLoggedIn, userId} = useSelector(
    (state: AppState) => state.auth,
    shallowEqual
  );
  const cityName = locationMap([filters?.loc]) || 'Cities';
  useEffect(() => {
    if (
      (calledType == 'category' || calledType == 'tag') &&
      page == LOCATION_BASED
    ) {
      const fetchJobs = async () => {
        setIsLoading(true);
        const fetchCityJobs = await jobfeedService.getNearByCityJobs({
          userId,
          minexp: filters?.minexp,
          maxexp: filters?.maxexp,
          loc: filters?.loc?.length
            ? filters?.loc?.join(',')
            : filters?.loc || null,
          ...(calledType == 'category'
            ? {catId: catOrTagId}
            : {query: catOrTagId}),
        });
        setCityJobs({hasMore: false, jobs: fetchCityJobs?.data});
        setIsLoading(false);
      };
      fetchJobs();
    }
  }, [filters]);
  const {
    profile: {subscriptions, proMembership, settings, tags, id, showSpotLight},
    completeness: {profileStatus},
    interviewSlots,
  } = useSelector((state: AppState) => state.user);

  const {searchOverlay, enableLoginPopup} = useSelector(
    (state: AppState) => state.app.layout,
    shallowEqual
  );

  const isBotUser = useSelector(
    (state: AppState) => state.app.context.isCrawlerBot,
    shallowEqual
  );

  const {jobfeed, isLoading, loadMoreEnabled, isFilterLoaded, totalJobs} =
    useSelector((state: AppState) => state.job);

  const enableProfileWidget = useMemo(() => {
    if (!isAboveMobile && profileStatus?.resumeAttached) {
      return false;
    }
    return true;
  }, [isAboveMobile, profileStatus?.resumeAttached]);

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const minexp = 0,
    maxexp = 0;

  const filterApplied = useMemo(() => {
    let value = false;
    for (const key in filters) {
      if (
        !!filters[key] &&
        !['page', 'sort', 'userId', 'catOrTagId', 'concat'].includes(key) &&
        filters[key]?.length &&
        !filters[key].includes(0)
      ) {
        value = true;
        break;
      }
    }
    if (page === 'search' && !value) return true;
    return value;
  }, [filters]);

  const getJobFeed = useCallback(async () => {
    dispatch({
      type: 'job/jobFeed/set_jobfeed_loading',
      payload: {isLoading: true, loadingSource: 'jobfeedLoading'},
    });
    const jobFeedResult = await getJobFeedCallByType(
      jobFeedType,
      {
        maxexp,
        userId,
        type: calledType,
        catOrTagId,
        param: filters,
        searchType,
      },
      dispatch
    );
    dispatch({
      type: 'job/jobFeed/set_jobfeed_loading',
      payload: {isLoading: false, loadingSource: 'jobfeedLoading'},
    });
    dispatch({
      type: 'job/jobFeed/set_filter_applied',
      payload: {isFilterApplied: false},
    });
    if (
      jobFeedResult?.error ||
      (jobFeedType === CATEGORY && catOrTagId === '-1' && !filterApplied)
    ) {
      dispatch({
        type: 'job/jobFeed/set_jobfeed_filter_loaded',
        payload: false,
      });
    }
  }, [
    maxexp,
    minexp,
    filters,
    userId,
    catOrTagId,
    jobFeedType,
    calledType,
    dispatch,
  ]);

  const jobFeedStore = useSelector((state: AppState) => state.job);

  useEffect(() => {
    if (
      [
        CATEGORY,
        TAG,
        SEARCH,
        LOCATION_BASED,
        RECRUITER_JOBFEED,
        ALUMNI,
      ].includes(jobFeedType) &&
      filters.page >= 0
    ) {
      getJobFeed();
    }
    if (jobFeedType === JOBFEED && filters.page >= 0) {
      getJobFeed();
    }
  }, [filters, catOrTagId]);

  useEffect(() => {
    console.log('🚀 ~ useEffect ~ preFilters:', preFilterApplied);
    dispatch(fetchIndustryData());

    if (
      (preFilterApplied &&
        ![LOCATION_BASED, CATEGORY, TAG].includes(jobFeedType)) ||
      jobFeedType === SEARCH
    ) {
      dispatch({
        type: 'job/jobFeed/set_jobfeed_filter_loaded',
        payload: true,
      });
    }
  }, []);

  const debounceOptions = {leading: true};

  const setPageQuery = debounce(
    (page: number) => {
      const initialPage = preFilters?.page || initialFilter.page;
      const pageNo = page + initialPage;
      if (pageNo <= 1) {
        setPageNo(0);
        setQueryParams({page: null});
        setPageNumber && setPageNumber(1);
      } else {
        setPageNo(pageNo);
        setQueryParams({page: pageNo});
        setPageNumber && setPageNumber(pageNo);
      }
    },
    250,
    debounceOptions
  );
  useEffect(() => {
    if (
      getCookie('2faEmailAction', {
        domain:
          process.env.NEXT_PUBLIC_TRAIL === 'true'
            ? 'localhost'
            : process.env.NEXT_PUBLIC_DOMAIN,
      }) == '1'
    ) {
      settwoFaActionOpen(true);
    }
  }, []);

  const onFilter = (
    filterData: /* eslint-disable @typescript-eslint/no-explicit-any */ any,
    clear = false
  ) => {
    const {experience, locationLabels, ...filterParams} = filterData;
    const filterExp: object = EXPERIENCE_MAPPING[parseInt(experience) - 1] ?? {
      minexp: 0,
      maxexp: 0,
    };

    const locationLabel = locationLabels?.replace(/ /g, '-') || '';

    const applyingFilter = {
      ...initialFilter,
      userId,
      catOrTagId,
      ...filterParams,
      //loc: filterParams?.loc?.join(','),
      sort: filterParams.sort?.join(','),
      ...filterExp,
    };

    if (!applyingFilter?.loc && jobFeedType === LOCATION_BASED) {
      applyingFilter['loc'] = preFilters.loc;
    }

    if (isAISearchRoute || !isEqual(applyingFilter, filters)) {
      dispatch({
        type: 'job/jobFeed/set_filter_applied',
        payload: {isFilterApplied: true},
      });

      setFilters(applyingFilter);

      // Create a separate object with only loc and exp fields
      const trackingFilters = {
        loc: applyingFilter.loc,
        minexp: applyingFilter.minexp,
        maxexp: applyingFilter.maxexp,
        duration: applyingFilter.posting?.[0],
        industry: applyingFilter.industry,
      };
      onFiltersChange?.(trackingFilters);

      if (jobFeedType === SEARCH) {
        const expFilters = clear ? {minexp: 0, maxexp: 0} : filterExp;
        const {query, ...newFilterParam} = filterParams;
        if (clear) {
          newFilterParam.posting = '';
        }
        if (
          newFilterParam?.industry &&
          Array.isArray(newFilterParam.industry)
        ) {
          newFilterParam.industry = newFilterParam.industry.join(',');
        }
        const queryData = query ? query : catOrTagId;
        if (!isAISearchRoute) {
          router.replace(
            {
              pathname: filterParams?.query
                ? `${ROUTE_SEARCH}/${kebabCase(
                    queryData?.toLowerCase().replace('&', '')
                  )}-jobs`
                : router.pathname,
              query: {
                ...router.query,
                ...expFilters,
                ...newFilterParam,
                loc: locationLabel,
              },
            },
            undefined,
            {shallow: true}
          );
          setQueryParams({
            // ...router.query,
            ...expFilters,
            ...filterParams,
            loc: locationLabel,
            sort: filterData?.sort || null,
          });
        }
      } else {
        if (filterParams?.industry?.length == 0) {
          filterParams.industry = '';
        }
        if (!isAISearchRoute) {
          setQueryParams({
            industry: '',
            // ...router.query,
            ...filterExp,
            ...filterParams,
            loc: locationLabel,
            sort: filterData?.sort || null,
          });
        }
      }
      dispatch({
        type: 'job/jobFeed/set_jobfeed_filter_loaded',
        payload: !clear,
      });
      handleTracking('jsclickJobFilter', {
        pagename: jobFeedType,
        ...filterData,
      });
      TrackEventUBA('filterJobListingClick', 'click', {
        pageName: jobFeedType,
        page: jobFeedType,
        categoryID: Number(catOrTagId),
        tagID: Number(catOrTagId),
        filterExp: JSON.stringify(filterExp),
        filterLocation: Array.isArray(filterData.loc)
          ? filterData.loc.join(',')
          : filterData.loc,
        filterIndustry: Array.isArray(filterData?.industry)
          ? filterData?.industry?.join(',')
          : filterData?.industry,
        sessionUsername: sessionStorage.getItem('userId') || '',
      });
    }

    if (jobFeedType === SEARCH) {
      setCatOrTagTitle(
        `Search for - ${filterData.query ?? (filters.query || '')}`
      );
    }
  };

  const routeToJobDetail = (jobSlug: string, jobId: string | number) => {
    let query = '';
    if (extractedParams && Object.keys(extractedParams).length > 0) {
      const params = new URLSearchParams();
      if (extractedParams.ref) params.append('ref', extractedParams.ref);
      if (extractedParams.utm_source)
        params.append('utm_source', extractedParams.utm_source);
      if (extractedParams.utm_medium)
        params.append('utm_medium', extractedParams.utm_medium);
      if (extractedParams.utm_campaign)
        params.append('utm_campaign', extractedParams.utm_campaign);
      query = params.toString();
    } else {
      query = formQueryParams('');
    }

    openUrl(
      `${ROUTE_JOB_DETAIL}/${jobSlug}-${jobId}${query ? '?' + query : ''}`
    );
  };

  useEffect(() => {
    let currentFilters: {[key: string]: string | number} = {};
    let sessionFilter = {};
    try {
      sessionFilter = getExpFilter(jobFeedType);
      if (jobFeedType === SEARCH) {
        sessionFilter = {};
      }
      currentFilters = {...sessionFilter, ...router.query};
      // if experience filter comes from the url, it needs to be set in the session storage

      setExpFilter(jobFeedType, {
        minexp: currentFilters.minexp,
        maxexp: currentFilters.maxexp,
      });
    } catch (error) {}
    const {loc, sort, minexp, maxexp, posting, page, industry} =
      currentFilters as ParsedUrlQuery;
    const location = getLocationIds(loc as string);
    const industryIds = (industry as string)?.split(',');
    const locationIds = location
      ? location?.split(',')?.map(v => parseInt(v))
      : null;
    let experience: any = EXPERIENCE_MAPPING.map(
      (x: any) => `${x.minexp}-${x.maxexp}`
    ).indexOf(`${minexp}-${maxexp}`);
    experience = experience > -1 ? [experience + 1] : null;
    const appliedFilters: any = {
      loc: locationIds,
      sort: sort ? [sort] : null,
      page: parseInt(page as string) || 0,
      experience,
      industry: industryIds,
      // query: preFilters.query,
      // posting: [parseInt(posting as string) || 0],
    };
    if (jobFeedType === SEARCH) {
      appliedFilters.query = preFilters.query;
    }
    if (posting) {
      appliedFilters.posting = [parseInt(posting as string)];
    }
    dispatch({
      type: 'job/jobFeed/set_filters',
      payload: {
        filters: appliedFilters,
        options: {showSort: jobFeedType === JOBFEED},
      },
    });

    const filterMapper = Object.assign({}, appliedFilters);
    delete filterMapper?.page;
    delete filterMapper?.sort;
    if (!Object.values(filterMapper).every(x => !x)) {
      dispatch({
        type: 'job/jobFeed/set_jobfeed_filter_loaded',
        payload: true,
      });
    }

    // if (jobFeedType === JOBFEED) {
    //   setFilters({...appliedFilters});
    // }
  }, []);

  /**
   * Premium products based logic append
   */

  useEffect(() => {
    if (userId && jobFeedType === JOBFEED) {
      (async () => {
        const invites = await calendarService.invites('invites');
        dispatch({
          type: 'User/set_user_interviewslots',
          payload: invites,
        });
      })();
    }
  }, [userId, jobFeedType]);

  const onLoadMore = (event: Event, target: HTMLElement) => {
    pageMaps.push(target.scrollTop || document.documentElement.scrollTop);
    setPageMaps(pageMaps);
    setFilters({
      ...filters,
      page: (filters.page || 0) + 1,
      concat: true,
    });
  };

  const premiumPurchase = [];

  if (showSpotLight) {
    premiumPurchase.push({
      title: 'Spotlight',
    });
  }

  if (proMembership?.isValid) {
    premiumPurchase.push({
      title: 'Pro Membership',
      actionLabel: `Valid till ${dayjs()
        .add(proMembership?.daysLeft, 'day')
        .format('DD MMM YYYY')}`,
      actionUrl: getProLink(
        'jf',
        '123',
        userProfileWidget?.refCode,
        userProfileWidget?.refFeature
      ),
    });
  }

  if (subscriptions?.earlyApplicant?.isValid && earlyApplicant?.enabled) {
    premiumPurchase.push({
      title: 'Early Applicant',
      actionLabel: `Valid till ${dayjs(
        subscriptions?.earlyApplicant?.validUpTo,
        'DD-MM-YYYY'
      ).format('DD MMM YYYY')}`,
      actionUrl: getOldLink(earlyApplicant?.redirectUrl),
    });
  }

  if (subscriptions?.resumeBuilder?.isValid && resumeBuilder?.enabled) {
    premiumPurchase.push({
      title: 'Resume Builder',
      actionLabel: `Valid till ${dayjs(
        subscriptions?.resumeBuilder?.validUpTo,
        'DD-MM-YYYY'
      ).format('DD MMM YYYY')}`,
      actionUrl: getOldLink(resumeBuilder?.redirectUrl),
    });
  }
  const filteredMulWidget = mulWidget?.content?.filter((info: any) => {
    if (info?.tag === 'earlyapplicant' && earlyApplicant?.enabled) {
      if (subscriptions?.earlyApplicant?.isValid) {
        return false;
      }
      return true;
    }

    return true;
  });

  if (
    typeof interviewSlots?.count === 'number' &&
    interviewSlots.count > 0 &&
    interviewSlots?.slots?.length
  ) {
    if (singleWidget?.content[0]?.actionUrl) {
      singleWidget.content[0].actionUrl =
        interviewSlots.count == 1
          ? getRefEmbedded(
              getOldLink(
                `/cal/pick-date/${interviewSlots.slots[0]?.calId || ''}/${
                  interviewSlots.slots[0].id || ''
                }`
              ),
              'WEB_SIDEBAR',
              'normal'
            )
          : getRefEmbedded(
              getOldLink(singleWidget?.content[0]?.actionUrl),
              'WEB_SIDEBAR',
              'normal'
            );
    }
  }

  const onScrollNew = () => {
    if (pageMaps.length) {
      let pageNo = 0;
      for (let i = 0; i <= pageMaps.length; i++) {
        if (pageMaps[i] < document.documentElement.scrollTop) {
          pageNo = pageNo + 1;
        } else {
          break;
        }
      }
      setPageQuery(pageNo + 1);
    }
  };

  const onLoginSuccess = async () => {
    if (isCSR()) {
      if (localStorage.getItem('applyJobIdsPostLogIn')) {
        const {profile} = await userService.profile('profile');
        if (profile) {
          const formatedProfile: UserState = getFormatedProfile(profile);
          const profileCom = formatedProfile?.completeness;
          const applyJobsData =
            localStorage.getItem('applyJobIdsPostLogIn') || '';
          if (applyJobsData?.length > 0) {
            let checkJobs: string[] = [];
            let refCodes: (number | undefined)[] = [];

            try {
              // Try to parse as JSON (new format)
              const jobsData = JSON.parse(applyJobsData);
              if (Array.isArray(jobsData)) {
                checkJobs = jobsData.map((item: any) => item.id);
                refCodes = jobsData.map((item: any) => item.refCode);
              } else {
                // Fallback to old comma-separated format
                checkJobs = applyJobsData.split(',');
              }
            } catch (e) {
              // Fallback to old comma-separated format
              checkJobs = applyJobsData.split(',');
            }

            console.log({prodile: profileCom?.percentage, checkJobs, refCodes});
            await applyMultipleJobs(
              checkJobs,
              profile,
              profileCom?.profileStatus,
              refCodes.length > 0 ? refCodes : undefined
            );
          }
        }
      } else {
        window.location.reload();
      }
    }
  };

  const onJobSave = () => {
    if (!isLoggedIn) {
      setLoginOpen(true);
    }
  };

  const handleClearFilter = () => {
    dispatch({
      type: 'job/jobFeed/set_filter_chips',
      payload: {chips: []},
    });
    if (isAISearchRoute) {
      const latestQuery =
        (filters as any)?.query ||
        (typeof catOrTagId === 'string' ? catOrTagId : '');
      onFilter({...initialFilter, query: latestQuery}, true);
    } else {
      onFilter(initialFilter, true);
    }
    if (
      process.env.NEXT_PUBLIC_FILTER_CAT_TAG === 'true' &&
      isAppIimjobs &&
      (page === CATEGORY || page === TAG || page == LOCATION_BASED)
    ) {
      localStorage.removeItem('filterCat');
      deleteCookie('filterCat');
    } else {
      localStorage.removeItem('filter');
      deleteCookie('filter');
    }
  };

  const disable2FAEmailActionPopup = () => {
    deleteCookie('2faEmailAction', {
      domain:
        process.env.NEXT_PUBLIC_TRAIL === 'true'
          ? 'localhost'
          : process.env.NEXT_PUBLIC_DOMAIN,
    });
  };

  const handle2FAClickAction = (path: string) => {
    openUrl(getOldLink(path), '_self');
  };
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const h1Title =
    jobFeedType == 'Courses' || jobFeedType == 'Companies'
      ? jobFeedType
      : catOrTagTitle.includes('Jobs') || catOrTagTitle.includes('jobs')
      ? jobFeedType == RECRUITER_JOBFEED
        ? `Jobs Posted`
        : catOrTagTitle
      : `${catOrTagTitle} Jobs`;

  const sendEvent = (
    eventCatogary: string,
    eventName: string,
    action: string
  ) => {
    handleTracking(`${eventName}_${action}`, {
      event_category: `${eventCatogary}`,
      Origin: page,
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
      Php_SessionID_Mod: sessionStorage.getItem('phpSessId') || '0',
    });
  };

  useEffect(() => {
    if (page === JOBFEED && isAboveMD) {
      sendEvent('App_Promotion', 'DownloadAppQR2Desktop', 'View');
    }
    if ((page === TAG || page === CATEGORY) && isAboveMD) {
      sendEvent('App_Promotion', 'DownloadAppQR1Desktop', 'View');
    }
  }, [page, isAboveMD]);
  const [SeoMetas, setSEOMetas] = useState({title: '', description: ''});
  const [checkCom, setCheckCom] = useState<Map<string, string | undefined>>(
    () => new Map()
  );

  useEffect(() => {
    if (page !== JOBFEED) {
      const {title, description} = getListSEOContent(
        props.catOrTagTitle,
        pageNo,
        totalJobs +
          (page === LOCATION_BASED &&
          cityJobs?.jobs?.length > 0 &&
          jobFeedStore?.jobfeed?.length <= 10
            ? cityJobs?.jobs?.length
            : 0)
      );

      setSEOMetas({
        title: page === RECRUITER_JOBFEED ? props.catOrTagTitle : title,
        description:
          isAppIimjobs && page === RECRUITER_JOBFEED ? '' : description,
      });
    }
  }, [totalJobs, cityJobs]);

  const isLarge = useIsLargeDevice();
  const isSmall = useIsCustomWidth(600);
  const [showFloatingDownloadButton, setShowFloatingDownloadButton] =
    useState(false);

  const [url, setUrl] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setUrl(window.location.href);
    }
  }, []);

  useEffect(() => {
    if (
      page === CATEGORY ||
      page === TAG ||
      page === SEARCH ||
      (page === JOBFEED &&
        (url.includes('/company') || url.includes('/courses')))
    ) {
      setShowFloatingDownloadButton(false);
    }
  }, [page, url]);
  const newTitle = h1Title.replace(/ in [^]+$/, ` Nearby ${cityName}`);
  return (
    <>
      {!isAppIimjobs && <InterviewInvitesNotifier />}
      {isCSR() && (isAppIimjobs || !(page == COURSE)) && (
        <SeoIntrup
          pageNo={pageNo}
          nextPage={!!loadMoreEnabled}
          type={'jobfeed'}
          title={SeoMetas.title}
          description={SeoMetas.description}
        />
      )}
      {!isAppIimjobs && calledType != 'company' && !feedOnly && (
        <Box
          mt={
            page === JOBFEED ||
            jobFeedType == 'Courses' ||
            jobFeedType == 'Company'
              ? 0
              : 4
          }
          mb={{xxs: '30px', md: jobFeedType === 'Company' ? '50px' : '100px'}}
        >
          {!['search'].includes(jobFeedType) &&
            !(router.query?.keyword && router.query?.keyword.length > 0) && (
              <ImageGallery />
            )}
          <Sticky
            enabled={true}
            top={
              (isLarge ? 98 : 88) -
              (page === JOBFEED ||
              jobFeedType == 'Courses' ||
              jobFeedType == 'Company'
                ? 34
                : 0)
            }
            innerZ={9}
            enableTransforms={false}
          >
            <Box
              px={{xxs: 3, md: 2}}
              id="navigation_listing_tabs"
              sx={{
                display: 'flex',
                background: '#fff',
                gap: {xxs: 7, md: 5},
                width: '100%',
                justifyContent: {xxs: 'center', md: 'flex-start'},
              }}
            >
              <TabLink
                onClick={() => {
                  deferTask(() => {
                    if (!isLoggedIn) {
                      window.location.href = '/';
                    } else {
                      window.location.href = '/jobfeed';
                    }
                  });
                }}
                className={
                  jobFeedType != 'Company' && jobFeedType != 'Courses'
                    ? 'active'
                    : ''
                }
                style={{
                  color:
                    jobFeedType !== 'Company' && jobFeedType !== 'Courses'
                      ? theme.palette.primary.main
                      : '#8d8d8d !important',
                }}
              >
                <Box>
                  <Typography>Jobs</Typography>
                </Box>
              </TabLink>
              <TabLink
                onClick={() => {
                  deferTask(() => {
                    if (!isAppIimjobs) {
                      handleTracking('jsClickCompaniesTab', {
                        UserId: sessionStorage.getItem('userId') || 'NA',
                        event_category: 'CompaniesTab',
                        Device: sessionStorage.getItem('device') || 'desktop',
                        Device_Type:
                          sessionStorage.getItem('deviceType') || 'web',
                      });
                    }
                    window.location.href = '/company';
                  });
                }}
                className={jobFeedType == 'Company' ? 'active' : ''}
                style={{
                  color:
                    jobFeedType == 'Company'
                      ? theme.palette.primary.main
                      : '#8d8d8d !important',
                }}
              >
                <Box>
                  <Typography>Companies</Typography>
                </Box>
              </TabLink>
              <TabLink
                onClick={() => {
                  deferTask(() => {
                    if (!isAppIimjobs) {
                      handleTracking('jsClickCoursesTab', {
                        UserId: sessionStorage.getItem('userId') || 'NA',
                        event_category: 'CompaniesTab',
                        Device: sessionStorage.getItem('device') || 'desktop',
                        Device_Type:
                          sessionStorage.getItem('deviceType') || 'web',
                      });
                    }
                    window.location.href = '/courses';
                  });
                }}
                className={jobFeedType == 'Courses' ? 'active' : ''}
                style={{
                  color:
                    jobFeedType == 'Courses'
                      ? theme.palette.primary.main
                      : '#8d8d8d !important',
                }}
              >
                <Box>
                  <Typography
                    style={{
                      color:
                        jobFeedType == 'Courses'
                          ? theme.palette.primary.main
                          : '#8d8d8d !important',
                    }}
                  >
                    Courses
                  </Typography>
                </Box>
              </TabLink>
            </Box>
          </Sticky>
        </Box>
      )}
      <Grid
        sx={{position: 'relative'}}
        container
        rowSpacing={2}
        columnSpacing={isAppIimjobs ? 2 : {md: 1, lg: 2, xl: 4}}
        mt={calledType == 'company' ? 7 : ''}
      >
        {showProfileCard &&
          enableProfileWidget &&
          isAppIimjobs &&
          isAboveMobile && (
            <Grid
              item
              xxs={12}
              md={2.3}
              xl={2}
              display={{xss: 'block', md: 'none', lg: 'block'}}
            >
              <ProfileCardHarness showSmallBadges={false} variant={variant} />

              {isAboveMobile &&
                singleWidget?.enabled &&
                typeof interviewSlots?.count === 'number' &&
                interviewSlots?.count > 0 && (
                  <CTA
                    cardSxProps={{
                      mt: 2,
                    }}
                    cardInfo={singleWidget?.content}
                    variant={VersionVariants.VERSION_FOUR}
                    dynamicValue={interviewSlots?.count.toString()}
                    valueToReplace="${slots}"
                  />
                )}

              {isAboveMobile && premiumPurchase.length > 0 && (
                <CTA
                  cardSxProps={{
                    mt: 2,
                  }}
                  cardInfo={premiumPurchase}
                  variant={VersionVariants.VERSION_FIVE}
                />
              )}

              {isAboveMobile && mulWidget?.enabled && (
                <CTA
                  cardSxProps={{
                    mt: 2,
                  }}
                  cardInfo={filteredMulWidget}
                  variant={VersionVariants.VERSION_FOUR}
                />
              )}
              {isAboveMD && page === JOBFEED && (
                <DownloadAppJobFeed sendEvent={sendEvent} />
              )}
            </Grid>
          )}

        <Grid
          item
          xxs={12}
          md={
            feedOnly || hideSidebar
              ? 12
              : showProfileCard && isAppIimjobs
              ? 6.7
              : 8.5
          }
          xl={
            feedOnly || hideSidebar
              ? 12
              : showProfileCard && isAppIimjobs
              ? 7
              : 9
          }
        >
          <InjectSearchOverlay isSearchEnabled={searchOverlay} />
          {jobFeedType == 'Company' ? (
            <>
              <HiristCompanyFeed companyJobs={props?.companyJobs} />
            </>
          ) : jobFeedType == 'Courses' ? (
            <HiristCourseFeed coursesArr={props.courses} />
          ) : (
            (() => {
              if (jobFeedType === JOBFEED && id && !tags?.length) {
                return (
                  <JobFeedEmpty
                    noTags={!tags?.length}
                    title={jobFeedType === JOBFEED ? MYJOBFEED : h1Title}
                  />
                );
              } else if (
                (jobFeedType !== SEARCH &&
                  (page != LOCATION_BASED || isAppIimjobs) &&
                  !isFilterLoaded &&
                  !jobfeed?.length &&
                  isLoading === false) ||
                (isBotUser && !jobfeed?.length)
              ) {
                return (
                  <JobFeedEmpty
                    noTags={false}
                    title={h1Title}
                    page={jobFeedType}
                  />
                );
              } else if (
                jobFeedType === SEARCH &&
                !jobFeedStore.jobfeed.length &&
                !isFilterLoaded &&
                !isLoading
              ) {
                return (
                  <JobFeedEmpty
                    noTags={false}
                    title={h1Title}
                    page={jobFeedType}
                  />
                );
              } else {
                return (
                  <>
                    <JobfeedHarness
                      onLoadMore={onLoadMore}
                      routeToJobDetail={routeToJobDetail}
                      title={
                        jobFeedType === JOBFEED
                          ? MYJOBFEED
                          : jobFeedType === RECRUITER_JOBFEED
                          ? 'Jobs Posted'
                          : h1Title
                      }
                      feedOnly={feedOnly}
                      onFilter={onFilter}
                      onClearFilter={handleClearFilter}
                      variant={variant}
                      // onInfiniteScroll={(e: MouseEvent, page: number) =>
                      //   setPageQuery(page)
                      // }
                      onJobSave={onJobSave}
                      onInfiniteScroll={onScrollNew}
                      infiniteScroll={true}
                      catId={catOrTagId}
                      checkJobs={checkCom}
                      cityJobs={cityJobs}
                      preFilters={preFilters}
                      extractedParams={extractedParams}
                      showIndustry={showIndustry}
                      showStickyFilter={showStickyFilter}
                      showApplyButton={showApplyButton}
                      showCourses={showCourses}
                      hideSidebar={hideSidebar}
                      calledType={calledType}
                      showFreeProBannerToday={showFreeProBannerToday}
                    />
                  </>
                );
              }
            })()
          )}
          {(calledType == 'category' || calledType == 'tag') &&
            page == LOCATION_BASED &&
            (cityJobs?.jobs?.length > 0 || isCitJobsLoading) &&
            jobFeedStore?.jobfeed?.length <= 10 &&
            (isCitJobsLoading ? (
              <Card sx={{mt: 2, borderRadius: 4}}>
                <Typography
                  component={'h2'}
                  marginTop={{xxs: 2, md: 3}}
                  marginLeft={2}
                  marginBottom={1}
                  color="var(--Font-Color-Font-color, #333)"
                  fontSize={20}
                  fontStyle="normal"
                  fontWeight={'500'}
                >
                  {newTitle}
                </Typography>
                {[...new Array(15)].map(index => {
                  return (
                    <Box display="flex" key={`jobfeed-skel-${index}`}>
                      <Skeleton
                        variant="rounded"
                        height={60}
                        sx={{
                          width: {xxs: '75px', md: '65px'},
                          mt: {xxs: 0, md: 1},
                          ml: 2,
                          mb: 1,
                        }}
                      />
                      <Box display="block" width="100%">
                        <Skeleton
                          variant="rounded"
                          width={'50%'}
                          height={20}
                          sx={{
                            mt: {xxs: 0, md: 1},
                            ml: {xxs: 2, md: 'none'},
                            mb: 1,
                          }}
                        />
                        <Skeleton
                          variant="rounded"
                          width={'90%'}
                          height={20}
                          sx={{
                            mt: {xxs: 0, md: 1},
                            ml: {xxs: 2, md: 'none'},
                            mb: 1,
                          }}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </Card>
            ) : (
              <Box
                ml={isAppIimjobs && page == LOCATION_BASED ? 0 : 2}
                sx={{
                  ...(isAppIimjobs && {
                    borderRadius: 2,
                    marginTop: 1,
                  }),
                }}
              >
                {!isAppIimjobs && (
                  <Typography component="h2" fontSize="20px" fontWeight={600}>
                    {newTitle}
                  </Typography>
                )}

                <CompanyJobFeed
                  title={isAppIimjobs ? newTitle : ''}
                  onLoadMore={() => {}}
                  companyJobs={cityJobs}
                  setCompanyJobList={setCityJobs}
                  checkJobs={checkCom}
                  setCheckJobs={setCheckCom}
                />
              </Box>
            ))}

          {!isAppIimjobs && showFloatingDownloadButton && isSmall && (
            <FloatingDownloadButton />
          )}
        </Grid>

        {!feedOnly && !hideSidebar && (
          <Grid
            item
            md={isAppIimjobs ? (showProfileCard ? 3 : 3.5) : 3.32}
            xl={isAppIimjobs ? (showProfileCard ? 3 : 3) : 2.85}
            ml={isAppIimjobs ? 0 : {xxs: '16px', md: 0}}
            mr={isAppIimjobs ? 0 : {xxs: '16px', md: 0}}
            sx={{
              display: {xxs: !!loadMoreEnabled ? 'none' : 'block', md: 'block'},
              width: '100%',
            }}
          >
            {jobFeedType === JOBFEED && !settings?.['hideStories'] ? (
              <>
                <StoryInjection />
              </>
            ) : (
              <></>
            )}
            {jobFeedType === JOBFEED && !isAppIimjobs && (
              <>
                <Box
                  sx={{
                    mb: 3.5,
                  }}
                >
                  <Typography
                    fontSize={16}
                    fontWeight={500}
                    color="secondary.main"
                    sx={{mb: 1.5}}
                  >
                    Profile Status
                  </Typography>
                  <ProfileCardHarness
                    showSmallBadges={false}
                    variant={VersionVariants.VERSION_ONE}
                  />
                </Box>

                {isAboveMobile && mulWidget?.enabled && (
                  <CTA
                    cardSxProps={{
                      mt: 2,
                      mb: 3.5,
                      borderRadius: 2,
                    }}
                    cardInfo={filteredMulWidget}
                    variant={VersionVariants.VERSION_FOUR}
                  />
                )}
              </>
            )}
            <AdsPanelHarness
              variant={variant}
              showSmallBadges={false}
              showFeatured={showFeatured}
              showLearning={showLearning}
              showLearnGrow={showLearnGrow}
              showFeaturedInstitute={showFeaturedInstitute}
              showRolesAtLeadingBrands={showRolesAtLeadingBrands}
              showPlatinumPartners={showPlatinumPartners}
              showSalesEvent={showSalesEvent}
              showLearningCenterCTA={showLearningCenterCTA}
              page={page == COMPANY || page == COURSE ? page : undefined}
              showEventOnly={
                isAppIimjobs || ['Courses', 'Company'].includes(jobFeedType)
                  ? false
                  : true
              }
            />
            {!isAppIimjobs && jobFeedType === LOCATION_BASED && (
              <JobsByLocation />
            )}
            {isAboveMD &&
              (page == TAG ||
                page == CATEGORY ||
                (!isAppIimjobs && page == JOBFEED)) && (
                <DownloadAppJobdetail sendEvent={sendEvent} />
              )}
            {!isAppIimjobs && device == 'desktop' && (
              <Box
                mt={3.75}
                sx={{
                  visibility: mounted ? 'visible' : 'hidden',
                }}
              >
                <BlogsPanel heading={'Stay updated with our blogs'} />
              </Box>
            )}
          </Grid>
        )}

        {isAppIimjobs && (
          <Dialog
            title="Login to your account"
            subtitle="Welcome back! 👋"
            invertedTitle
            variant={VersionVariants.VERSION_TWO}
            open={loginOpen}
            onClose={() => setLoginOpen(false)}
          >
            <LoginForm
              onSuccess={onLoginSuccess}
              variant={VersionVariants.VERSION_TWO}
            />
          </Dialog>
        )}

        {!isAppIimjobs && (
          <HiristAuthentication
            variant={VersionVariants.VERSION_TWO}
            onSuccess={onLoginSuccess}
            openDialog={enableLoginPopup || loginOpen}
            enableSignIn={true}
            setOpenDialog={() => {
              dispatch({
                type: 'AppContext/set_login_popup',
                payload: false,
              });
              setLoginOpen(false);
            }}
          />
        )}

        <Dialog
          title="2-Step Verification"
          subtitle="Action Required!"
          invertedTitle={true}
          variant={VersionVariants.VERSION_TWO}
          open={twoFaActionOpen}
          onClose={() => {
            settwoFaActionOpen(false);
            disable2FAEmailActionPopup();
          }}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'flex-start'}
            gap={1}
            px={1}
            pt={1}
          >
            <Image
              src={CautionIcon}
              alt={'caution'}
              data-name="2fa"
              width={32}
              height={32}
              objectFit="cover"
              quality={50}
            />
            <Typography
              color="secondary.main"
              variant="subtitle2"
              lineHeight={'21px'}
            >
              {
                "We noticed that you do not have access to the phone number you've enabled for 2-Step Verification."
              }
            </Typography>
          </Box>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'flex-start'}
            gap={1}
            px={1}
            pt={1}
            pb={2}
          >
            <Typography color="#7e7e7e" lineHeight={'18px'} variant="body3">
              {
                'Before continuing, we request you to change your number to ensure a smoother experience while logging in to your iimjobs account. Alternatively, you may also disable the 2-Step Verification.'
              }
            </Typography>
          </Box>
          <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
            onClick={() => disable2FAEmailActionPopup()}
            gap={1.5}
            px={1}
          >
            <Box
              width={'100%'}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
              border={'1px solid #7e7e7e20'}
              borderRadius={2}
              px={1.5}
              py={1}
              sx={{
                cursor: 'pointer',
              }}
              onClick={() => handle2FAClickAction('/mfasettings?cn=1')}
            >
              <Link
                href={getOldLink('/mfasettings?cn=1')}
                target="_blank"
                color="secondary.main"
                fontSize={'12px'}
                lineHeight={'16px'}
                fontWeight={500}
                sx={{
                  textDecoration: 'none',
                  ':hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                {'Change number'}
              </Link>
              <Image
                src={ChevronRight}
                alt={'Arrow'}
                width={12}
                height={12}
                objectFit="cover"
              />
            </Box>
            <Box
              width={'100%'}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
              border={'1px solid #7e7e7e20'}
              borderRadius={2}
              px={1.5}
              py={1}
              sx={{
                cursor: 'pointer',
              }}
              onClick={() => handle2FAClickAction('/mfasettings?da=1')}
            >
              <Link
                href={getOldLink('/mfasettings?da=1')}
                target="_blank"
                color="secondary.main"
                fontSize={'12px'}
                lineHeight={'16px'}
                fontWeight={500}
                sx={{
                  textDecoration: 'none',
                  ':hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                {'Disable 2-Step Verification'}
              </Link>
              <Image
                src={ChevronRight}
                alt={'Arrow'}
                width={12}
                height={12}
                objectFit="cover"
              />
            </Box>
            <Button
              onClick={() => settwoFaActionOpen(false)}
              sx={{
                color: 'primary.main',
                padding: '0px 0px 8px 12px',
                ':hover': {
                  textDecoration: 'underline',
                  background: '#fff',
                },
              }}
            >
              {"I'll do this later"}
            </Button>
          </Box>
        </Dialog>
      </Grid>
    </>
  );
};

export default JobFeed;
